/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpportunityKpiProjection
 */
export interface OpportunityKpiProjection {
    /**
     * 
     * @type {string}
     * @memberof OpportunityKpiProjection
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OpportunityKpiProjection
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof OpportunityKpiProjection
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof OpportunityKpiProjection
     */
    average: number;
    /**
     * 
     * @type {number}
     * @memberof OpportunityKpiProjection
     */
    total: number;
}

/**
 * Check if a given object implements the OpportunityKpiProjection interface.
 */
export function instanceOfOpportunityKpiProjection(value: object): value is OpportunityKpiProjection {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('average' in value) || value['average'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function OpportunityKpiProjectionFromJSON(json: any): OpportunityKpiProjection {
    return OpportunityKpiProjectionFromJSONTyped(json, false);
}

export function OpportunityKpiProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunityKpiProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'count': json['count'],
        'average': json['average'],
        'total': json['total'],
    };
}

export function OpportunityKpiProjectionToJSON(json: any): OpportunityKpiProjection {
    return OpportunityKpiProjectionToJSONTyped(json, false);
}

export function OpportunityKpiProjectionToJSONTyped(value?: OpportunityKpiProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'count': value['count'],
        'average': value['average'],
        'total': value['total'],
    };
}

